module.exports = __webpack_public_path__ + "static/media/abt-2.21c58037.png";